import WarrantyActivationService from '@/services/Warranty'

export const state = () => ({})

export const mutations = {}

export const actions = {
  checkSerialNumber ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      WarrantyActivationService.checkSerialNumber(
        {
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload
      )
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  checkModelName ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      WarrantyActivationService.checkModelName(
        {
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload
      )
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  activateWarranty ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      WarrantyActivationService.activateWarranty(
        {
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload
      )
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  warrantyActivations ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      WarrantyActivationService.warrantyActivations(
        {
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload
      )
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  }
}
